module.exports = __webpack_public_path__ + "static/media/banner-harineradeoriente.6aef0d4f.jpg";